import config from '../../config';
import api from '../../utils/callApi';
const paymentBaseUrl = config.PAYMENT_PAGE_URL;

function testPaymentStatus(trackingId, apiRequestData) {
    return () => {
        return api.post('Widget/CheckPaymentAuthorizedAsync', {
            ...apiRequestData,
            trackingId
        });
    };
}

let pollingInterval;
let pollingPromise;

function pollForPaymentCompletion(trackingId, apiRequestData) {
    if (pollingPromise) return pollingPromise;
    pollingPromise = new Promise((resolve, reject) => {
        pollingInterval = setInterval(() => {
            testPaymentStatus(trackingId, apiRequestData)().then(data => {
                if (data.authorized) {
                    resolve(data);
                    clearInterval(pollingInterval);
                }
            });
        }, 500);
    });

    return pollingPromise;
}

const openTabs = [];

export const paymentPageCleanup = () => {
    if (pollingInterval) clearInterval(pollingInterval);
    pollingInterval = null;
    pollingPromise = null;

    var tab;
    while ((tab = openTabs.pop())) {
        try {
            tab.close();
        } catch (err) {} //user probably already closed it or used it for something else
    }
};

export const spawnPaymentTab = (
    paymentType,
    trackingId,
    btClientId,
    apiRequestData,
    amount,
    label,
    charity
) => {
    paymentPageCleanup();
    const url = `${paymentBaseUrl}?type=${paymentType}&id=${trackingId}&clientId=${btClientId}&apiData=${encodeURIComponent(
        JSON.stringify(apiRequestData)
    )}&amount=${amount}&label=${label}&charity=${charity}`;

    const newTab = window.open(url);
    openTabs.push(newTab);

    return pollForPaymentCompletion(trackingId, apiRequestData);
};
